module.exports = __webpack_public_path__ + "static/img/best_sound_editing_frame_1.6cf2d04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best_sound_editing_frame_1.jpg
// module id = 288
// module chunks = 0